<template>
  <entity-view
    :item-schemas="itemSchemas"
    :readonly="readonly"
    :items="items"
    :title="$t('invoice')"
    :pagination="pagination"
    :externalActions="externalActions"
    :options="options"
    @items-refresh="itemsRefresh"
    @item-action="itemAction"
    @page-change="pageChange"
    @double-click-row="clickRow"
  >
    <template v-slot:icon="item">
      <v-icon v-if="item.value" small color="success">
        mdi-check-circle
      </v-icon>
      <v-icon v-if="!item.value" small color="error">
        mdi-close-circle
      </v-icon>
    </template>
  </entity-view>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import CommonTypes from "../common/common_type";

export default {
  components: { EntityView },
  props: {
    lawyerId: {},
    userId: {},
    paid: {}
  },
  data: () => ({
    title: "Invoice",
    select: true,
    expendOpen: false,
    readonly: true,
    selectedIdx: 0,
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    itemSchemas: [
      {
        name: "id",
        value: "id",
        type: "string",
      },
      {
        name: "orderNo",
        value: "orderNo",
        type: "string",
      },
      {
        name: "orderId",
        value: "orderId",
        type: "string",
      },
      {
        name: "userId",
        value: "userId",
        type: "string",
      },
      {
        name: "userName",
        value: "userName",
        type: "string",
      },
      {
        name: "lawyerId",
        value: "lawyerId",
        type: "string",
      },
      {
        name: "lawyerName",
        value: "lawyerName",
        type: "string",
      },
      {
        name: "amount",
        value: "amount",
        type: "number",
      },
      {
        name: "sharePercent",
        value: "sharePercent",
        type: "number",
      },
      {
        name: "revenueShare",
        value: "revenueShare",
        type: "number",
      },
      {
        name: "lawyerShare",
        value: "lawyerShare",
        type: "number",
      },
      {
        name: "createdAt",
        value: "createdAt",
        type: "datetime",
      },
      {
        name: "paid",
        value: "paid",
        type: "dropdown",
        localized: true,
        dropdown: CommonTypes.booleans,
      },
    ],
    items: [],
    externalActions: [],
  }),
  mounted() {
    this.updateSchemaData();
    this.refresh();
  },
  computed: {
    options: function () {
      return {
        dateTimePattern: this.$root.$config.dateTimePattern,
        datePattern: this.$root.$config.datePattern,
        showAction: false,
      };
    },
  },
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
    },
    refresh() {
      let _this = this;
      let postData = {
        pagination: this.pagination,
        criterias: [],
      };
      if (postData.criterias != undefined) {
        if (this.lawyerId != undefined) {
          postData.criterias.push({
            operator: "=",
            type: "string",
            value: this.lawyerId,
            column: "lawyer_id",
            condition: "and",
          });
        }

        if (this.userId != undefined) {
          postData.criterias.push({
            operator: "=",
            type: "string",
            value: this.userId,
            column: "user_id",
            condition: "and",
          });
        }

        if (this.paid != undefined) {
          postData.criterias.push({
            operator: "=",
            type: "boolean",
            value: this.paid,
            column: "paid",
            condition: "and",
          });
        }
      }
      this.post("/api/invoices", postData, {
        callback: function (data) {
          let pg = {
            pageCount: data.data.pages,
            pageSize: data.data.size,
            current: data.data.current,
          };
          _this.pagination = pg;
          _this.items = data.data.records;
        },
      });
    },
    itemsRefresh() {
      this.refresh();
    },
    clickRow(item) {
      this.$router.push({
        name: "InvoiceDetail",
        params: { id: item.id + "" },
      });
    },
    filter() {
      this.refresh();
    },
    clearFilter() {
      this.$refs.filterView.clear();
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction(name) {
      if (name === "insert") {
        this.itemCreate();
      }
    },
    selectIdx(idx) {
      this.selectedIdx = idx;
      this.refresh();
    },
  },
};
</script>

<style scoped>
.filter-label {
  margin-left: -12px !important;
}
</style>

<i18n>
{
  "en": {
  },
  "cn": {
  }
}
</i18n>
